import React from "react"

import Banner from "../Banner/Banner"
import Button from "../Button/Button"
import CaptionImage from "../Media/CaptionImage"
import Copy from "../Copy/Copy"
import Columns from "../Columns/Columns"
import Forms from "../Forms/Forms"
import ImageSlider from "../ImageSlider/ImageSlider"
import Listing from "../Listing/Listing"
import RichText from "../RichText"
import Video from "../Video/Video"

import * as m from "../../models/modules"
import RecipeCollectionListing from "../Listing/ListingTypes/RecipeCollectionListing"

interface RenderBodyModuleProps {
  block: m.BodyModuleObj
  hasSidebar?: boolean
  pageContext: any
}

const defaultProps = {}

export const RenderBodyModule: React.FC<RenderBodyModuleProps> = props => {
  // console.log("RenderBodyModule: ", props.block)
  if (!props.block) return null

  /*************************************
    Banner
  *************************************/
  if (props.block["banner"])
    return (
      <>
        {(props.block["banner"] as m.BannerModule).banner.map(banner => (
          <Banner
            key={banner.id}
            {...banner}
            embed
            pageContext={props.pageContext}
          />
        ))}
      </>
    )

  /*************************************
    Button
  *************************************/
  if (props.block["button"]) {
    const block = props.block["button"] as m.ButtonModule
    if (block?.button)
      // predefined button
      return (
        <div className="embed">
          {block.button.map(button => (
            <Button
              key={button.id}
              {...button}
              pageContext={props.pageContext}
            />
          ))}
        </div>
      )

    return (
      <div className="embed">
        <Button
          label={block.label}
          anchor={block.anchor}
          pageContext={props.pageContext}
        />
      </div>
    )
  }

  /*************************************
    Columns
  *************************************/
  if (props.block["columns"]) {
    const columns = props.block["columns"] as m.ColumnsModule
    return (
      <Columns {...columns} cssClass="embed" pageContext={props.pageContext} />
    )
  }

  /*************************************
    Copy
  *************************************/
  if (props.block["copy"])
    return (
      <>
        {(props.block["copy"] as m.CopyModule).copy.map(copy => (
          <Copy
            key={copy.id}
            content={copy.content}
            cssClass="embed"
            pageContext={props.pageContext}
          />
        ))}
      </>
    )

  /*************************************
    Form
  *************************************/
  if (props.block["form"]) {
    const forms = props.block["form"] as m.FormModule
    return <Forms {...forms} pageContext={props.pageContext} />
  }

  /*************************************
    Image - Caption Image
  *************************************/
  if (props.block["image"])
    return (
      <CaptionImage
        {...(props.block["image"] as m.ImageModule)}
        pageContext={props.pageContext}
      />
    )

  /*************************************
    Image Slider
  *************************************/
  if (props.block["image_slider"])
    return (
      <ImageSlider
        {...(props.block["image_slider"] as m.ImageSliderModule)}
        pageContext={props.pageContext}
      />
    )

  /*************************************
    Listing
  *************************************/
  if (props.block["listing"])
    return (
      <Listing
        {...(props.block["listing"] as m.ListingModule)}
        cssClass="embed"
        hasSidebar={props.hasSidebar}
        pageContext={props.pageContext}
      />
    )
  /*************************************
    Recipe Collection Listing
  *************************************/
  if (props.block["recipe_collection"])
    return (
      <RecipeCollectionListing
        {...(props.block[
          "recipe_collection"
        ] as m.RecipeCollectionListingModule)}
        pageContext={props.pageContext}
      />
    )

  /*************************************
    Rich Text
  *************************************/
  if (props.block["rich_text"])
    return (
      <RichText
        content={(props.block["rich_text"] as m.RichTextModule).rich_text}
        cssClass="content embed"
        pageContext={props.pageContext}
      />
    )

  /*************************************
    Rich Text (HTML)
  *************************************/
  if (props.block["html_text"])
    return (
      <div
        className="content embed"
        dangerouslySetInnerHTML={{
          __html: (props.block["html_text"] as m.HTMLTextModule).html,
        }}
      />
    )

  /*************************************
    Video
  *************************************/
  if (props.block["video"])
    return (
      <Video
        {...(props.block["video"] as m.VideoModule)}
        pageContext={props.pageContext}
      />
    )

  return null
}

RenderBodyModule.defaultProps = defaultProps

export default RenderBodyModule
